import { configurationSettings, TicketRedemptionCodeCategory } from '@vista/omnichannel-components-domain';
import { TicketRedemptionCardType } from '@vista-digital/ocapi-types/v1';
export const getTicketRedemptionCodeTypeForCard = (card) => {
    switch (card.type) {
        case TicketRedemptionCardType.MemberSubscriptionCard:
            return getTypeForMemberSubscription(card.subscriptionId);
        case TicketRedemptionCardType.ThirdPartyMemberCard:
            return getTypeForThirdPartyMemberScheme(card.thirdPartyMemberSchemeId);
        default:
            return undefined;
    }
};
const getTypeForMemberSubscription = (subscriptionId) => {
    const { ticketRedemptionCodeTypes } = configurationSettings.data;
    return ticketRedemptionCodeTypes.find(type => {
        if (type.category !== TicketRedemptionCodeCategory.MemberSubscriptionCard)
            return false;
        return type.subscriptionId === subscriptionId;
    });
};
const getTypeForThirdPartyMemberScheme = (thirdPartyMemberSchemeId) => {
    const { ticketRedemptionCodeTypes } = configurationSettings.data;
    return ticketRedemptionCodeTypes.find(type => {
        if (type.category !== TicketRedemptionCodeCategory.ThirdPartyMemberCard)
            return false;
        return type.thirdPartyMemberSchemeId === thirdPartyMemberSchemeId;
    });
};
